/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type SputumTestMaterialResultDtoTestResult =
  (typeof SputumTestMaterialResultDtoTestResult)[keyof typeof SputumTestMaterialResultDtoTestResult];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SputumTestMaterialResultDtoTestResult = {
  PENDING: 'PENDING',
  POSITIVE: 'POSITIVE',
  NEGATIVE: 'NEGATIVE',
  NOT_EXECUTED: 'NOT_EXECUTED',
} as const;
